import type { Viewport } from '../shared/protocol';

export function readViewport(): Viewport {
  const width = Math.max(1, Math.round(window.innerWidth));
  const height = Math.max(1, Math.round(window.innerHeight));
  return {
    width,
    height,
    dpr: Math.min(8, Math.max(1, window.devicePixelRatio || 1)),
    orientation: width >= height ? 'landscape' : 'portrait'
  };
}
